// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PageContentWrapper_contentContainer__2voli"};